// extracted by mini-css-extract-plugin
module.exports = {"alert":"_5608097"};